import React, {Component} from "react";
import { Fab, Menu, MenuItem} from "@material-ui/core";
import toRenderProps from "recompose/toRenderProps";
import withState from "recompose/withState";
import { withStyles } from "@material-ui/core/styles";
import MenuTowTone from "@material-ui/icons/MenuTwoTone";
import {Link} from "react-router-dom";
import Can from "../../services/RolePermissionService";

const WithState = toRenderProps(withState("anchorEl", "updateAnchorEl", null));

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    }
});


class RenderPropsMenu extends Component {
    
    constructor(props){
        super();
    }

    render() {

        const { section, isAuthenticated, history } = this.props;
        // console.debug("headerResMenu",this.props);
        return (
            <WithState>
                {({ anchorEl, updateAnchorEl }) => {
                    const open = Boolean(anchorEl);
                    const handleClose = () => {
                        updateAnchorEl(null);
                    };

                    const signOut = () => {
                        this.props.userLogOut();
                        this.props.resetMerchantDetails();
                        updateAnchorEl(null);
                    };

                    const goAdmin = () => {
                        updateAnchorEl(null);
                        history.push("/admin");
                    };

                    return (
                        <div>
                            <Fab
                                aria-owns={open ? "render-props-menu" : null}
                                color="primary"
                                size="small"
                                aria-haspopup="true"
                                onClick={event => {
                                    updateAnchorEl(event.currentTarget);
                                }}
                            >
                                <MenuTowTone/>
                            </Fab>

                            {isAuthenticated ?
                                <Menu id="render-props-menu" anchorEl={anchorEl} open={open} onClose={handleClose}>
                                    {section.map(section => (
                                        <Can do="view" on={section.url} key={section.name}>
                                            <MenuItem key={section.name} onClick={handleClose} component={Link}
                                                to={section.url}>
                                                {section.name}
                                            </MenuItem>
                                        </Can>
                                    ))}
                                    <Can do="view" on='/admin' >
                                        <MenuItem onClick={goAdmin}>
                                            Admin
                                        </MenuItem>
                                    </Can>
                                    <MenuItem onClick={signOut}>
                                        Logout
                                    </MenuItem>                                                       
                                }
                                </Menu>
                                :
                                <Menu id="render-props-menu" anchorEl={anchorEl} open={open} onClose={handleClose}>                             
                                    <MenuItem onClick={handleClose} component={Link} to={"/"}>
                                            Sign in
                                    </MenuItem>
                                    {process.env.REACT_APP_ENV === "development" ?                                     
                                        <MenuItem onClick={handleClose} component={Link} to={"/signup"}>
                                            Sign up
                                        </MenuItem> 
                                        :
                                        null
                                    }    
                                </Menu>
                            }        
                        </div>
                    );
                }}
            </WithState>
        );
    }
}

export default withStyles(styles)(RenderPropsMenu);
